import { HtmlToStringPipe } from './../../../../../pipes/html-to-string.pipe';
import { Component, Input, OnInit } from '@angular/core';
import { StudentEligibilitiesService } from '../../../service/student-eligibilities.service';

@Component({
    selector: 'view-child-eligibility-checkboxes',
    templateUrl: './view-child-eligibility-checkboxes.component.html',
    styleUrls: ['./view-child-eligibility-checkboxes.component.scss']
})
export class ViewChildEligibilityCheckboxesComponent implements OnInit {
    @Input() studentId!: number;
    @Input() showMatDivider: boolean = true;

    minYear: number = 2016;
    performancePeriods: any[];
    currentPerformancePeriod: string;
    performancePeriodIndex: number;
    eligibilityCategoryTypes: any[] = [];

    eip: boolean = false;
    eipReason: string = '';

    isLoading: boolean = false;
    promises: Array<any> = [];

    htmlToStringPipe = new HtmlToStringPipe();

    constructor(private studentEligibilitiesService: StudentEligibilitiesService) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;

        this.indexEligibilityCategoryTypes();
        this.performancePeriods = this.populatePerformancePeriods(0, 1);

        Promise.all(this.promises).then((res) => {
            this.promises = [];

            this.getStudentEligibilityByCategory();
            this.getEiPReason();

            Promise.all(this.promises).then((res) => {
                this.isLoading = false;
            });
        });
    }

    changePerformancePeriod(index: number, direction: number) {
        this.performancePeriodIndex = index + direction;
        this.currentPerformancePeriod = this.performancePeriods[this.performancePeriodIndex];

        this.refreshEligibilities();
    }

    refreshEligibilities() {
        this.promises = [];
        this.isLoading = true;

        this.getStudentEligibilityByCategory();
        this.getEiPReason();

        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    populatePerformancePeriods(yearsBack: number, yearsForward: number): string[] {
        const today = new Date();
        const currentMonth: number = today.getMonth() + 1;
        let currentYear: number;

        if (currentMonth >= 9) {
            currentYear = today.getFullYear();
        } else {
            currentYear = today.getFullYear() - 1;
        }

        if (this.minYear) {
            yearsBack = currentYear - this.minYear;
        }

        let output: string[] = [];

        // Populate yearsBack
        for (let i = yearsBack; i > 0; i--) {
            output.push(this.yearReducer(currentYear - i));
        }

        // Populate currentYear
        output.push(this.yearReducer(currentYear));
        this.currentPerformancePeriod = this.yearReducer(currentYear);

        // Populate yearsForward if any
        if (yearsForward > 0) {
            for (let i = 1; i <= yearsForward; i++) {
                output.push(this.yearReducer(currentYear + i));
            }
        }

        output = output.sort((a, b) => a.localeCompare(b));

        this.performancePeriodIndex = output.findIndex((pp) => pp === this.currentPerformancePeriod);

        return output;
    }

    yearReducer(currentYear: number): string {
        let output = currentYear.toString() + '-' + this.nextYear(currentYear);

        return output;
    }

    nextYear(currentYear: number): string {
        let nextYearInt: number = currentYear + 1;

        return nextYearInt.toString().substring(2, 4);
    }

    indexEligibilityCategoryTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.indexEligibilityCategoryTypes().subscribe((res) => {
                if (res.eligibilityCategoryTypes) {
                    this.eligibilityCategoryTypes = res.eligibilityCategoryTypes;

                    this.eligibilityCategoryTypes.forEach((category) => {
                        category.TOOLTIP = this.htmlToStringPipe.transform(category.TOOLTIP);
                    });

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentEligibilityByCategory() {
        let deferred = new Promise((resolve, reject) => {
            this.eligibilityCategoryTypes.forEach((category, index) => {
                this.studentEligibilitiesService.getStudentEligibilityByCategory(this.studentId, this.currentPerformancePeriod, category).subscribe((res) => {
                    if (res.eligiblityStatus) {
                        this.eligibilityCategoryTypes[index][this.currentPerformancePeriod] = res.eligiblityStatus;

                        resolve(res);
                    } else if (res?.msg) {
                        resolve(res);
                    } else {
                        reject('err');
                    }
                });
            });
        });

        this.promises.push(deferred);
    }

    getEiPReason() {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getEiPReason(this.studentId, this.currentPerformancePeriod).subscribe((res) => {
                if (res.msg?.SUCCESS) {
                    this.eip = true;
                    this.eipReason = res.msg?.MSG;

                    resolve(res);
                } else if (res?.msg) {
                    this.eip = false;
                    this.eipReason = res.msg?.MSG;

                    resolve(res);
                } else {
                    this.eip = false;
                    this.eipReason = 'Error getting EiP Reason';

                    resolve('err');
                }
            });
        });

        this.promises.push(deferred);
    }
}
